$(function($) {
    "use strict";

    var $win = $(window);
    var $body = $(document.body);

    $('[sticky-after]').each(function() {
        var $element = $(this);

        var base = $element.parent();
        var block = $element;

        var previos = $($element.attr('sticky-after'));
        var bodyclass = $element.attr('on-fixed-bodyClass');

        // prepare base:
        base.height($element.height());

        function render() {

            var prevHeight = previos.outerHeight();

            var baseTop = base.offset().top;
            var scrollTop = $win.scrollTop() + prevHeight;

            var blockBottom = (scrollTop - baseTop);

            if (blockBottom >= 0) {
                block.addClass("fixed").css('top', prevHeight);
                $body.addClass(bodyclass);
            } else {
                block.removeClass("fixed").css('top', 0);
                base.height($element.height());
                $body.removeClass(bodyclass);
            }
        }

        $(document).on('scroll',
            function() {
                render();
            });
        render();

        // window.test = render;

    });

});